import { Point } from '@turf/turf';

export interface IFsLprResult {
  id: string;
  plate: string;
  plateImageUrl: string;
  contextImageUrl: string;
  vehicleMake: string;
  vehicleBody: string;
  type: string;
  isHit: boolean;
  hitReason: string;
  geometry: Point;
  state: string;
  createdTimestamp: Date;
  cameraName: string;
  displayState: string;
  imageUrl?: string;
  integratedLprType?: string;
  vehicleColor?: string;
}
